// extracted by mini-css-extract-plugin
export default {"empty":"List_empty_B2oZw"};